<template>
  <div 
    @contextmenu.prevent="null"
    style="display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100%; width: 100%; cursor: default; user-select: none;"
  >
    <h1>Página no encontrada</h1>
    <p style="font-size: large; margin-top: 5px;">La página buscada dejó de existir o probablemente nunca existió.</p>
    <v-btn 
      @click="this.$generalFunctions.default.navigateTo('/')"
      color="indigo"
      class="hoverableText"
      style="margin-top: 25px;"
    >
      <v-icon size="large" style="margin-right: 10px;">mdi-home</v-icon>
      <h3>Volver a la página de inicio</h3>
    </v-btn>
  </div>
</template>

<script>
  export default {
    inject: ['$generalFunctions'],  
  }
</script>